let routerInstance = null;

/**
 * Sets the router instance. This is called once in `main.js`.
 * @param {Object} router - The Vue Router instance.
 */
export function setRouter(router) {
    routerInstance = router;
}

export function getRouter() {
    return routerInstance;
}